<template>
  <div>
    <v-card
      outlined
      tile
      style="border-top:0"
    >
      <div class="px-4">
        <div
          v-for="(item,i) in categories.data"
          :key="item.id"
        >
          <v-row
            no-gutters
            align="center"
            class="py-4 flex-nowrap"
          >
            <v-col
              cols="10"
              class="pe-4 text-truncate"
            >
              <div
                class="text-h5 black--text cursor-pointer"
                @click="navigateToGoodsList(item)"
              >
                {{ $store.getters.languageGetter === '1' ? item.dnames : item.dnamesEn }}
              </div>
            </v-col>
            <v-col
              v-if="item.son"
              cols="2"
              :class="$store.getters.languageGetter === '1' ? 'text-left' : 'text-right'"
            >
              <v-btn
                icon
                :color="item.son ? 'black' : 'grey'"
                x-small
                @click="toggleSubCate(i)"
              >
                <v-icon>{{ cateToggle[i] ? 'mdi-minus' : 'mdi-plus' }}</v-icon>
              </v-btn>
            </v-col>
          </v-row>
          <v-expand-transition>
            <div
              v-if="item.son && cateToggle[i]"
            >
              <v-divider />
              <div class="py-2">
                <div
                  v-for="subitem in item.son"
                  :key="subitem.id"
                  class="py-1"
                >
                  <div
                    class="sub-category cursor-pointer"
                    :class="$route.query.categoryName === subitem.dnames ? 'active' : ''"
                    @click="navigateToGoodsList(subitem)"
                  >
                    {{ $store.getters.languageGetter === '1' ? subitem.dnames : subitem.dnamesEn }}
                  </div>
                </div>
              </div>
            </div>
          </v-expand-transition>
          <v-divider v-if="i < categories.data.length - 1" />
        </div>
      </div>
    </v-card>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'CategoryList',
  data() {
    return {
      cateToggle: [],
    };
  },
  computed: {
    ...mapState(['categories']),
  },
  created() {
    this.setCateToggle();
  },
  methods: {
    setCateToggle() {
      this.cateToggle = new Array(this.categories.length).fill(false);
    },
    toggleSubCate(i) {
      if (this.cateToggle[i]) {
        this.setCateToggle();
        this.$set(this.cateToggle, i, false);
      } else {
        this.setCateToggle();
        this.$set(this.cateToggle, i, true);
      }
    },
    navigateToGoodsList(item) {
      this.$store.commit('goods/RESET_GOODS_LIST');
      this.$router.push({
        name: 'GoodsList',
        query: {
          categoryId: item.id,
          categoryName: item.dnames,
          categoryNameEn: item.dnamesEn,
          p: 1,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.sub-category {
  position: relative;
  transition: all 0.2s ease-in-out;

  &::before {
    content: '°';
    position: absolute;
    top: 8px;
    transform: scale(2);
    left: 0;
    margin-top: -2px;
    color: #999;
    opacity: 0;
    transition: all 0.2s ease-in-out;
  }

  &:hover,
  &.active {
    padding-left: 10px;
    font-weight: bold;

    &::before {
      opacity: 1;
      font-weight: normal;
    }
  }
}
</style>
